/* Nieuw megamenu (12-10-2026), gedrag van snippets/vm-megamenu.liquid.

   Muis: "Alle categorieën" en de balk-items openen na een korte hover
   (OPEN_DELAY, zodat langs de balk naar de zoekbalk bewegen niets opent). Staat
   het paneel al open, dan wisselt het direct. Sluiten SLUIT_DELAY na het
   verlaten van het menu. In de lijst wisselt een categorie pas na AIM_DELAY als
   de muis schuin naar rechts beweegt, anders springt de uitklapper weg op weg
   naar een link.
   Touch: eerste tik opent, tweede tik volgt de link.
   Toetsenbord: Enter/spatie op de knop opent en zet de focus in de lijst,
   pijl-omlaag op een balk-item opent dat item, Escape sluit. */
(function () {
  'use strict';

  var root = document.querySelector('[data-vm-mm]');
  if (!root || root.hasAttribute('data-vm-mm-klaar')) return;
  root.setAttribute('data-vm-mm-klaar', '');

  var OPEN_DELAY = 120;
  var SLUIT_DELAY = 100;
  var AIM_DELAY = 120;

  var alle = root.querySelector('[data-vm-mm-alle]');
  var paneel = root.querySelector('[data-vm-mm-paneel]');
  if (!alle || !paneel) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vm-mm-tab]'));
  var cats = Array.prototype.slice.call(paneel.querySelectorAll('[data-vm-mm-cat]'));
  var flys = {};
  Array.prototype.forEach.call(paneel.querySelectorAll('[data-vm-mm-fly]'), function (f) {
    flys[f.getAttribute('data-vm-mm-fly')] = f;
  });

  var header = document.querySelector('[data-site-header]');
  var muis = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktop = window.matchMedia('(min-width: 1024px)');

  var modus = null; /* null | 'alle' | 'balk' */
  var cur = root.getAttribute('data-vm-mm-eerste') || (cats[0] && cats[0].getAttribute('data-vm-mm-cat')) || '';
  var balkCur = null;
  var geopendOp = 0;
  var openTimer = null;
  var sluitTimer = null;
  var aimTimer = null;

  function toonFly(idx) {
    Object.keys(flys).forEach(function (k) {
      flys[k].hidden = k !== String(idx);
    });
  }

  function markeerCats() {
    cats.forEach(function (c) {
      c.setAttribute('aria-current', c.getAttribute('data-vm-mm-cat') === cur ? 'true' : 'false');
    });
  }

  function zetAria() {
    alle.setAttribute('aria-expanded', modus === 'alle' ? 'true' : 'false');
    tabs.forEach(function (t) {
      var aan = modus === 'balk' && t.getAttribute('data-vm-mm-tab') === balkCur;
      t.setAttribute('aria-expanded', aan ? 'true' : 'false');
    });
  }

  function open(m, idx) {
    clearTimeout(openTimer);
    clearTimeout(sluitTimer);
    openTimer = null;
    if (!modus) geopendOp = Date.now();
    modus = m;
    if (m === 'alle') {
      if (idx != null) cur = String(idx);
      toonFly(cur);
      markeerCats();
    } else {
      balkCur = String(idx);
      toonFly(balkCur);
    }
    paneel.classList.toggle('is-balk', m === 'balk');
    paneel.hidden = false;
    root.classList.add('is-open');
    zetAria();
    var top = paneel.getBoundingClientRect().top;
    paneel.style.setProperty('--vm-mm-top', Math.max(0, Math.round(top)) + 'px');
  }

  function sluit() {
    clearTimeout(openTimer);
    clearTimeout(sluitTimer);
    clearTimeout(aimTimer);
    openTimer = null;
    if (!modus) return;
    modus = null;
    paneel.hidden = true;
    root.classList.remove('is-open');
    zetAria();
  }

  function kiesCat(idx) {
    idx = String(idx);
    if (idx === cur) return;
    cur = idx;
    toonFly(cur);
    markeerCats();
  }

  /* ---------- muis ---------- */
  root.addEventListener('mouseover', function (e) {
    if (!muis.matches || !desktop.matches) return;
    clearTimeout(sluitTimer);
    var knop = e.target.closest('[data-vm-mm-alle]');
    var tab = e.target.closest('[data-vm-mm-tab]');
    if (!knop && !tab) return;
    var m = knop ? 'alle' : 'balk';
    var idx = tab ? tab.getAttribute('data-vm-mm-tab') : null;
    if (modus === m && (m === 'alle' || balkCur === idx)) return;
    clearTimeout(openTimer);
    if (modus) {
      open(m, idx);
      return;
    }
    openTimer = setTimeout(function () {
      open(m, idx);
    }, OPEN_DELAY);
  });

  /* Muis verlaat een knop of balk-item voor de vertraging om is: niet openen. */
  root.addEventListener('mouseout', function (e) {
    if (!openTimer) return;
    var van = e.target.closest('[data-vm-mm-alle], [data-vm-mm-tab]');
    if (van && !(e.relatedTarget && van.contains(e.relatedTarget))) {
      clearTimeout(openTimer);
      openTimer = null;
    }
  });

  root.addEventListener('mouseleave', function () {
    if (!muis.matches) return;
    clearTimeout(openTimer);
    openTimer = null;
    sluitTimer = setTimeout(sluit, SLUIT_DELAY);
  });

  root.addEventListener('mouseenter', function () {
    clearTimeout(sluitTimer);
  });

  /* Sfeerbeelden vooraf laden zodra muis of focus het menu bereikt; anders start het ophalen pas bij het aanwijzen
     van een categorie en verschijnt het beeld een halve seconde later. Zelfde 1x/2x-keuze als image-set in de CSS;
     onder 1280px tonen we geen sfeerbeeld, dus dan ook niet laden. */
  var sfeerGeladen = false;
  var sfeerBreed = window.matchMedia('(min-width: 1280px)');
  function laadSfeer() {
    if (sfeerGeladen || !sfeerBreed.matches) return;
    sfeerGeladen = true;
    var attr = (window.devicePixelRatio || 1) > 1 ? 'data-vm-mm-sfeer-2x' : 'data-vm-mm-sfeer-1x';
    Array.prototype.forEach.call(root.querySelectorAll('[data-vm-mm-sfeer-1x]'), function (s) {
      new Image().src = s.getAttribute(attr);
    });
  }
  root.addEventListener('mouseenter', laadSfeer);
  root.addEventListener('focusin', laadSfeer);

  /* Schuinvertraging in de lijst */
  var lastX = 0;
  var lastY = 0;
  var dx = 0;
  var dy = 0;
  paneel.addEventListener('mousemove', function (e) {
    dx = e.clientX - lastX;
    dy = e.clientY - lastY;
    lastX = e.clientX;
    lastY = e.clientY;
  });

  paneel.addEventListener('mouseover', function (e) {
    if (!muis.matches || modus !== 'alle') return;
    if (e.target.closest('.vm-mm__fly')) {
      clearTimeout(aimTimer); /* aangekomen in de uitklapper: niet meer wisselen */
      return;
    }
    var c = e.target.closest('[data-vm-mm-cat]');
    if (!c) return;
    clearTimeout(aimTimer);
    var idx = c.getAttribute('data-vm-mm-cat');
    var naarRechts = dx > 1 && Math.abs(dy) < dx * 2.5;
    if (naarRechts) {
      aimTimer = setTimeout(function () {
        kiesCat(idx);
      }, AIM_DELAY);
    } else {
      kiesCat(idx);
    }
  });

  paneel.addEventListener('mouseleave', function () {
    clearTimeout(aimTimer);
  });

  /* ---------- klikken en tikken ---------- */
  alle.addEventListener('click', function (e) {
    e.preventDefault();
    var toetsenbord = e.detail === 0;
    if (modus === 'alle') {
      /* net via hover geopend: deze klik is dezelfde beweging, niet dichtklappen */
      if (!toetsenbord && muis.matches && Date.now() - geopendOp < 500) return;
      sluit();
      return;
    }
    open('alle');
    if (toetsenbord) {
      var huidig = paneel.querySelector('[data-vm-mm-cat="' + cur + '"]') || cats[0];
      if (huidig) huidig.focus();
    }
  });

  tabs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      if (muis.matches) return; /* muis: gewoon naar de collectie */
      var idx = t.getAttribute('data-vm-mm-tab');
      if (modus === 'balk' && balkCur === idx) return; /* tweede tik: link volgen */
      e.preventDefault();
      open('balk', idx);
    });

    t.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault();
      var idx = t.getAttribute('data-vm-mm-tab');
      open('balk', idx);
      var eerste = flys[idx] && flys[idx].querySelector('a');
      if (eerste) eerste.focus();
    });
  });

  cats.forEach(function (c) {
    c.addEventListener('click', function (e) {
      var idx = c.getAttribute('data-vm-mm-cat');
      if (c.hasAttribute('data-vm-mm-geen-link')) {
        e.preventDefault();
        clearTimeout(aimTimer);
        kiesCat(idx);
        return;
      }
      if (!muis.matches && idx !== cur) {
        e.preventDefault();
        kiesCat(idx);
      }
    });

    c.addEventListener('focus', function () {
      if (modus === 'alle') kiesCat(c.getAttribute('data-vm-mm-cat'));
    });
  });

  /* ---------- sluiten ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !modus) return;
    var terug = modus === 'balk'
      ? root.querySelector('[data-vm-mm-tab="' + balkCur + '"]')
      : alle;
    var focusBinnen = root.contains(document.activeElement);
    sluit();
    if (focusBinnen && terug) terug.focus();
  });

  root.addEventListener('focusout', function (e) {
    if (!modus) return;
    if (e.relatedTarget && root.contains(e.relatedTarget)) return;
    if (!e.relatedTarget) return; /* klik op niets: de document-klik regelt dat */
    sluit();
  });

  document.addEventListener('click', function (e) {
    if (modus && !root.contains(e.target)) sluit();
  });

  /* De header klapt de menubalk in bij omlaag scrollen; dan hoort het paneel dicht. */
  window.addEventListener('scroll', function () {
    if (modus && header && header.classList.contains('vm-nav-uit')) sluit();
  }, { passive: true });

  /* Balk-items die niet passen van achteren af verbergen (Uitverkoop blijft).
     Alles is ook via Alle categorieën bereikbaar. */
  var balk = root.querySelector('.vm-mm__balk');
  function pasBalk() {
    if (!balk) return;
    var items = Array.prototype.slice.call(balk.children).filter(function (li) {
      return !li.classList.contains('vm-mm__balk-los');
    });
    items.forEach(function (li) { li.classList.remove('is-verborgen'); });
    if (!desktop.matches) return;
    for (var i = items.length - 1; i >= 0 && balk.scrollWidth > balk.clientWidth + 1; i--) {
      items[i].classList.add('is-verborgen');
    }
  }

  var pasGepland = false;
  function planPas() {
    if (pasGepland) return;
    pasGepland = true;
    window.requestAnimationFrame(function () {
      pasGepland = false;
      pasBalk();
    });
  }

  pasBalk();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pasBalk);
  window.addEventListener('load', pasBalk);

  window.addEventListener('resize', function () {
    if (modus) sluit();
    planPas();
  }, { passive: true });
})();

/* Lade (mobiel en tablet): de lade beslaat het hele scherm, elke categorie
   en kolom is een eigen laag. Een tik schuift de volgende laag van rechts
   over het scherm, de pijl in de kopbalk schuift hem weer weg en zet de
   vorige laag terug op dezelfde scrollpositie. Alles blijft binnen Empire's
   .mobile-nav-panel, het enige scrollgebied dat Empire's scroll-lock toelaat. */
(function () {
  'use strict';

  var mob = document.querySelector('[data-vm-mmm]');
  if (!mob || mob.hasAttribute('data-vm-mmm-klaar')) return;
  mob.setAttribute('data-vm-mmm-klaar', '');

  var nav = mob.closest('[data-mobile-nav]');
  var paneel = mob.closest('[data-mobile-nav-panel]');
  if (!nav || !paneel) return;
  nav.classList.add('vm-mmm-actief');

  var lagen = {};
  Array.prototype.forEach.call(mob.querySelectorAll('[data-vm-mmm-laag]'), function (l) {
    lagen[l.getAttribute('data-vm-mmm-laag')] = l;
  });

  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var stapel = ['root'];
  var scrollPos = {};
  var bezig = false;

  function huidig() {
    return stapel[stapel.length - 1];
  }

  /* Inlogregel en Empire's kruis verdwijnen in diepere lagen; de kopbalk neemt
     het over. Pas na de animatie aanzetten, anders springt de laag eronder. */
  function zetDiep() {
    nav.classList.toggle('vm-mmm-diep', stapel.length > 1);
  }

  /* top binnen .vm-mmm waarop een absolute laag precies bovenin beeld staat */
  function zichtbareTop() {
    return paneel.scrollTop - mob.offsetTop;
  }

  function naAnimatie(el, klasse, klaar) {
    var gedaan = false;
    function af() {
      if (gedaan) return;
      gedaan = true;
      el.removeEventListener('animationend', af);
      el.classList.remove(klasse);
      klaar();
    }
    if (rustig.matches) {
      af();
      return;
    }
    el.addEventListener('animationend', af);
    setTimeout(af, 450); /* vangnet als animationend uitblijft */
  }

  function focusKopbalk(laag) {
    var knop = laag.querySelector('[data-vm-mmm-terug]');
    if (knop) knop.focus({ preventScroll: true });
  }

  function vooruit(id) {
    var nieuw = lagen[id];
    var oud = lagen[huidig()];
    if (!nieuw || !oud || bezig) return;
    bezig = true;
    scrollPos[huidig()] = paneel.scrollTop;
    stapel.push(id);
    nieuw.style.top = zichtbareTop() + 'px';
    nieuw.hidden = false;
    nieuw.classList.add('is-in');
    naAnimatie(nieuw, 'is-in', function () {
      oud.hidden = true;
      nieuw.style.top = '';
      zetDiep();
      paneel.scrollTop = 0;
      bezig = false;
      focusKopbalk(nieuw);
    });
  }

  function terug() {
    if (stapel.length < 2 || bezig) return;
    bezig = true;
    var oudId = stapel.pop();
    var oud = lagen[oudId];
    var ouder = lagen[huidig()];
    zetDiep();
    ouder.hidden = false;
    paneel.scrollTop = scrollPos[huidig()] || 0;
    oud.style.top = zichtbareTop() + 'px';
    oud.classList.add('is-uit');
    naAnimatie(oud, 'is-uit', function () {
      oud.hidden = true;
      oud.style.top = '';
      bezig = false;
      var knop = ouder.querySelector('[data-vm-mmm-naar="' + oudId + '"]');
      if (knop) knop.focus({ preventScroll: true });
    });
  }

  function naarBegin() {
    Object.keys(lagen).forEach(function (k) {
      var l = lagen[k];
      l.hidden = k !== 'root';
      l.classList.remove('is-in', 'is-uit');
      l.style.top = '';
    });
    stapel = ['root'];
    scrollPos = {};
    bezig = false;
    zetDiep();
  }

  mob.addEventListener('click', function (e) {
    var naar = e.target.closest('[data-vm-mmm-naar]');
    if (naar) {
      e.preventDefault();
      vooruit(naar.getAttribute('data-vm-mmm-naar'));
      return;
    }
    if (e.target.closest('[data-vm-mmm-terug]')) {
      e.preventDefault();
      terug();
      return;
    }
    if (e.target.closest('[data-vm-mmm-sluit]')) {
      e.preventDefault();
      var sluit = nav.querySelector('[data-mobile-nav-close]');
      if (sluit) sluit.click();
    }
  });

  /* Bij opnieuw openen altijd bij de hoofdlijst beginnen. Empire zet
     data-open op de lade bij openen. */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (nav.getAttribute('data-open') === 'true') naarBegin();
    }).observe(nav, { attributes: true, attributeFilter: ['data-open'] });
  }
})();
